<div class="login-section">
    
  <div class="mb-login-container" [ngStyle]="{'background-image': 'url('+portalBackground+')'}">
    <div *ngIf='globals.Session == null' class="mb-login-form">
        <p class="login-title text-center" [innerHTML]="portalTitle | safe_html"></p>
        <form #loginForm="ngForm">
            <div id="login-form">
                <div [ngClass]="{'arrow-bottom':true, 'validation-has-error':true, 'show': isEmptyUsername}">
                    <span>Username is required</span>
                </div>
                <div [ngClass]="{'arrow-bottom':true, 'validation-invalid' : true, 'show': isInvalid }">
                    <span>Invalid Login</span>
                </div>
                <div class="flex-group">
                <span class="flex-addon">
                    <img src="../../assets/images/profile-circle.png" width="20" height="20">
                </span>
                <input #username autofocus type="text" [ngClass]="{'username-tb':true, 'red-border': isEmptyUsername || isInvalid }" name="username-mybiz" placeholder="Username" autocomplete="username-mybiz"
                (keyup)="openModal(template, username.value, $event)" required [disabled]="submitted"/>
                <div>
                    <button type="button" class="btn btn-default login-btn-popup" (click)="launchModal(template, username.value)" [ngStyle]="{'background-color': primaryColour}">LOGIN</button>
                </div>
                </div>
                <div style="margin-top: 10px;text-align:center;">
                    <a class="forgot-login-details" (click)="forgotLoginDetails()">FORGOT LOGIN DETAILS ></a>
                    <p class="login-terms" *ngIf="showLoginTerms">By continuing, you agree to the following 
                        <a href="../../assets/files/Terms of Use.pdf"
                        title="Terms of Use.pdf" 
                        target="_blank">Terms of Use</a>
                    </p>
                </div>
            </div>
        </form>
    </div>
    <div *ngIf="globals.Session">
      <span>Welcome {{globals.Session.DisplayName}}, </span>
      <span>Your last login was {{globals.Session.LastLogin | date:'d MMM yyyy h:mm aa'}}</span>
    </div>
  </div>
</div>